import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';
import { MantineTabs } from '@dealstack/frontend/shared/components/MantineTabs/MantineTabs.tsx';
import { TabsProps } from '@mantine/core';
import { ReactNode } from 'react';

interface Props<T extends string> {
	tabs: MantineTabProps<T>[];
	panels: { value: T; content: JSX.Element }[];
	defaultValue?: T;
	value?: T;
	onTabChange?: TabsProps['onChange'];
	rightContent?: ReactNode;
}

/**
 * Tabs sized for a {@link DetailsPanels} side panel. The panel already draws the border
 * separating it from the main region, so the tab strip only needs its own divider —
 * `onlyDividerBorder` keeps a second box border from doubling up on that edge.
 */
export const DetailsSidePanelTabs = <T extends string>({
	tabs,
	panels,
	defaultValue,
	value,
	onTabChange,
	rightContent,
}: Props<T>) => (
	<MantineTabs<T>
		tabs={tabs}
		panels={panels}
		defaultValue={defaultValue}
		value={value}
		onTabChange={onTabChange}
		rightContent={rightContent}
		onlyDividerBorder
	/>
);
